import { QuestionPlanMealConditions as Question } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/meal-conditions";

import { useDayTripPlanMealConditions } from "./hooks";

export const QuestionDayTripPlanMealConditions = () => {
	const { isEdited, hasError, error, rawIncludedMeals, onToggleMeal } = useDayTripPlanMealConditions();

	return (
		<Question
			isEdited={isEdited}
			hasError={hasError}
			error={error}
			rawIncludedMeals={rawIncludedMeals}
			onToggleMeal={onToggleMeal}
		/>
	);
};

QuestionDayTripPlanMealConditions.displayName = "QuestionDayTripPlanMealConditions";
